import { ref } from 'vue';
import { tools } from '@/utils/tools';
import CONFIG from '@/config/config';
// 添加日志
// import useVolLog from '@/hooks/vol-log';
// import { useUserStore } from '@/store';
export default function useFhTable(listFn, dataFilter) {
  const localPageSizeKey = CONFIG.prefix + 'fhTablePageSize';
  const psLocal = tools.getCookie(localPageSizeKey);
  const defaultProps = {
    'row-key': 'id',
    hoverable: true,
    // stripe: true,
    size: 'small',
    'column-resizable': true,
    loading: true,
    data: [],
    pagination: {
      current: 1,
      pageSize: psLocal ? Number(psLocal) : 20,
      total: 0,
      showPageSize: true, // 是否显示数据条数选择器
      showJumper: true,
      pageSizeOptions: [10, 20, 30, 40, 50, 100],
      size: 'small',
      isSaveLocal: true, // 是否保存本地分页大小
      totalContent: true // 是否显示数据总数
    },
    sortOrder: {
      colKey: '',
      sortOrder: ''
    }
  };
  const tProps = ref(defaultProps);
  // 分页
  const setPage = ({ current = 1, total }) => {
    if (tProps.value.pagination) {
      tProps.value.pagination.current = current;
      total >= 0 && (tProps.value.pagination.total = total);
    }
  };
  // 加载效果
  const setTLoading = (status) => {
    tProps.value.loading = !!status;
  };
  // 设置额外属性   closePage 是否关闭分页组件
  const setTProps = (params) => {
    const par = params || {};
    for (const key in par) {
      // defaultProps[key] = params[key];
      if (key === 'pagination' && params[key]) {
        defaultProps[key] = { ...defaultProps[key], ...params[key] };
      } else {
        defaultProps[key] = params[key];
      }
    }
  };
  // 增加额外的列表参数
  const loadListParams = ref({});
  const setLoadListParams = (params) => {
    // console.log('setLoadListParams333', JSON.parse(JSON.stringify(params)));

    if (params) loadListParams.value = { ...loadListParams.value, ...params };
  };

  // 排序的默认参数
  const sortObj = ref({});

  // 加载分页列表数据
  const loadTList = async (page, loading) => {
    if (listFn) {
      try {
        let listData = [];
        if (loading !== false) {
          setTLoading(true);
        }
        const par = {
          // page_size: tProps.value?.pagination.pageSize,
          // model: tProps.value.pagination.model,
          // ...tProps.value.pagination,
          ...sortObj.value,
          ...loadListParams.value,
          page: page || tProps.value.pagination?.current,
          pageSize: tProps.value.pagination?.pageSize
        };
        tProps.value.sortOrder = {
          colKey: sortObj.value?.sortField ?? '',
          sortOrder: sortObj.value?.sortRule ? 'ascend' : 'descend'
        };
        console.log('par111', JSON.parse(JSON.stringify(par)));
        if (par.entity == 16) delete par.scope;
        const data = await listFn(par);
        // -------------------------------------------------------
        // 日志
        // const track = useVolLog();
        // const modeLists = ['production', 'pc2', 'matrixProd', 'kaixian'];
        // const mode = import.meta.env.MODE;
        // const userStore = useUserStore();
        // if (modeLists.includes(mode)) {
        //   track.send({
        //     type: 'listPage',
        //     page: window.location.href,
        //     orgName: userStore.userInfo?.orgName || '-',
        //     userName: userStore.userInfo?.userName || '-',
        //     orgId: userStore.userInfo?.orgId || '-',
        //     userId: userStore.userInfo?.id || '-',
        //     feishu: !!window.h5sdk,
        //     params: par
        //   });
        // }
        // -------------------------------------------------------
        console.log('par222', data);
        const res = data.result || {};
        if (res?.records?.length) {
          listData = res?.records || [];
          setPage({ current: res?.current || 1, total: res?.total ?? res?.records?.length });
        } else {
          listData = [];
          setPage({ current: 1, total: 0 });
        }
        if (dataFilter) {
          listData = (await dataFilter(listData)) || listData || [];
        }
        tProps.value.data = listData;
        setTLoading(false);
        return data;
      } catch (e) {
        if (e.code !== 'ERR_CANCELED') setTLoading(false);
        return [];
      }
    } else {
      setTLoading(false);
      return [];
    }
  };

  // 事件触发组
  const tPropsEvent = ref({
    //排序触发
    sorterChange: (colKey, direction) => {
      setPage({ current: 1 });
      console.log(92, colKey, direction);
      let o = {};
      if (direction) {
        o = { sortField: colKey, sortRule: direction === 'ascend' ? true : false };
      }
      sortObj.value = o;
      console.log(921, colKey, direction, sortObj.value);
      loadTList();
    },
    //分页触发
    pageChange: ({ current, pageSize }) => {
      console.log(86, current);
      setPage({ current });
      tProps.value.pagination && (tProps.value.pagination.pageSize = pageSize);
      if (tProps.value.pagination.isSaveLocal) {
        // 保存本地分页大小
        tools.setCookie(localPageSizeKey, pageSize <= 100 ? pageSize : 100, 365);
      }
      loadTList();
    }
    // 修改每页显示条数
    // pageSizeChange: ({ pageSize, pageInfo }) => {
    //   console.log(92, pageSize, pageInfo);
    //   loadTList();
    // }
  });
  // 表格编辑时实时更新表格数据
  const setData = (rowIndex, newData) => {
    if (newData) {
      console.log('更新表格数据了', rowIndex, newData);
      tProps.value.data.splice(rowIndex, 1, newData);
    }
  };
  return {
    tProps,
    tPropsEvent,
    setTProps,
    setTLoading,
    setPage,
    setLoadListParams,
    sortObj,
    loadTList,
    setData
  };
}
